/* Homyria cushion C2, revision 29/09/2026. Native discounts enforce prices.
   29/10/2026 (Claude, demande de Loïc) : code du pack appliqué par cart/update.js (codes existants conservés)
   au lieu d'un fetch du lien /discount/ qui échouait ; si la réduction n'est pas confirmée, passage par le lien
   /discount/CODE?redirect=/cart : Confort+ et Duo mènent toujours directement au panier, comme l'Essentiel. */
(() => {
  'use strict';
  if (customElements.get('homyria-knee-offer')) return;
  class KneeOffer extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const raw = this.querySelector('[data-knee-config]');
      if (!raw) return;
      try { this.config = JSON.parse(raw.textContent); } catch (_) { return; }
      this.ready = true;
      this.button = this.querySelector('[data-knee-add]');
      this.message = this.querySelector('[data-knee-message]');
      this.cartLink = this.querySelector('[data-knee-cart]');
      this.pending = null;
      this.querySelectorAll('input[type=radio]').forEach(input => input.addEventListener('change', () => this.paint()));
      this.button.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); this.add(); });
      if ((this.config.currency || 'CHF') !== 'CHF') {
        const radios = Array.from(this.querySelectorAll('input[type=radio]'));
        radios.forEach(input => { input.disabled = this.config.offers[input.value]?.available === false; });
        if (this.config.offers[this.pack()]?.available === false) { const first = radios.find(input => !input.disabled); if (first) first.checked = true; }
      }
      this.paint();
    }
    text(key) { return this.config.strings?.[key] || ''; }
    pack() { return this.querySelector('input[type=radio]:checked')?.value || 'kit'; }
    money(cents) {
      const currency = this.config.currency || 'CHF';
      if (currency === 'CHF') return 'CHF ' + (cents / 100).toFixed(2);
      return new Intl.NumberFormat(this.config.locale || 'fr', { style: 'currency', currency }).format(cents / 100);
    }
    paint() {
      const p = this.config.offers[this.pack()];
      this.querySelector('[data-knee-price]').textContent = this.money(p.price);
      this.querySelector('[data-knee-included]').textContent = p.included;
      const heading = this.querySelector('[data-knee-heading]');
      const lead = this.querySelector('[data-knee-lead]');
      if (heading && p.heading) heading.textContent = p.heading;
      if (lead && p.lead) lead.textContent = p.lead;
      this.button.textContent = this.text('add') + ' — ' + this.money(p.price);
      this.button.disabled = !!this.busy || p.available === false;
      this.message.textContent = '';
      this.cartLink.hidden = true;
    }
    root() { return window.Shopify?.routes?.root || '/'; }
    async request(path, payload) {
      const response = await fetch(this.root() + path, {
        method: payload === undefined ? 'GET' : 'POST', credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: 'application/json', ...(payload === undefined ? {} : { 'Content-Type': 'application/json' }) },
        ...(payload === undefined ? {} : { body: JSON.stringify(payload) })
      });
      let data;
      try { data = await response.json(); } catch (_) { throw new Error(this.text('cart_error')); }
      if (!response.ok) throw new Error(data.description || data.message || this.text('unavailable'));
      return data;
    }
    relevant(cart) { return cart.items.filter(i => [this.config.cushion, this.config.cover].includes(Number(i.variant_id))); }
    operationItems(cart) { return cart.items.filter(i => i.properties?._hm_knee_operation === this.pending?.id); }
    discountLink(code) { return this.root() + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.HomyriaCart.compact ? window.HomyriaCart.returnUrl() : this.root() + 'cart'); }
    async applyCode(code, cart) {
      // Keep the codes already in the cart (e.g. BIENVENUE10) and add the pack code; drop the other cushion pack codes.
      const keep = (cart.discount_codes || []).map(d => d.code).filter(c => c && !/^HMKNEE2/i.test(c));
      await this.request('cart/update.js', { discount: keep.concat(code).join(',') });
    }
    async add() {
      if (this.busy || window.hmKneeCartBusy || window.hmHookCartBusy) return;
      const key = this.pack(), offer = this.config.offers[key];
      if (offer.available === false) return;
      this.busy = window.hmKneeCartBusy = true;
      this.button.disabled = true;
      this.button.textContent = this.text('checking');
      this.message.textContent = '';
      this.cartLink.hidden = true;
      this.querySelectorAll('input[type=radio]').forEach(i => { i.disabled = true; });
      try {
        let cart = await this.request('cart.js');
        if (cart.currency !== (this.config.currency || 'CHF')) throw new Error(this.text('currency_error'));
        if (this.pending && this.pending.pack !== key && this.operationItems(cart).length) throw new Error(this.text('pending_error'));
        if (this.relevant(cart).some(i => i.properties?._hm_knee_pack !== key || i.properties?._hm_knee_version !== 'C2-20260929')) throw new Error(this.text('existing_error'));
        if (!this.pending || this.pending.pack !== key) this.pending = { id: 'hm-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10), pack: key };
        if (!this.operationItems(cart).length) {
          const properties = { '_hm_knee_version': 'C2-20260929', '_hm_knee_pack': key, '_hm_knee_operation': this.pending.id, [this.text('formula')]: offer.name };
          const items = [{ id: this.config.cushion, quantity: offer.cushions, properties }];
          if (offer.covers) items.push({ id: this.config.cover, quantity: offer.covers, properties });
          this.button.textContent = this.text('adding');
          await this.request('cart/add.js', { items });
        }
        if (offer.code) {
          cart = await this.request('cart.js');
          try { await this.applyCode(offer.code, cart); } catch (_) {}
        }
        cart = await this.request('cart.js');
        const own = this.operationItems(cart);
        const cushions = own.filter(i => Number(i.variant_id) === this.config.cushion).reduce((s, i) => s + i.quantity, 0);
        const covers = own.filter(i => Number(i.variant_id) === this.config.cover).reduce((s, i) => s + i.quantity, 0);
        const price = own.reduce((s, i) => s + Number(i.final_line_price), 0);
        if (cushions !== offer.cushions || covers !== offer.covers || !Number.isFinite(price) || price < 0) throw new Error(this.text('verify_error'));
        // A valid supplementary discount may lower this amount; it must never raise it.
        if (price > offer.price) {
          if (!offer.code) throw new Error(this.text('verify_error'));
          this.message.textContent = this.text('added');
          window.location.assign(this.discountLink(offer.code));
          return;
        }
        this.message.textContent = this.text('added');
        const opened=await window.HomyriaCart.afterAdd(()=>{window.location.assign(this.root() + 'cart');});
        if(opened&&window.HomyriaCart.compact)this.pending=null;
      } catch (error) {
        this.message.textContent = error.message || this.text('retry');
        this.cartLink.hidden = false;
        this.cartLink.href = this.root() + 'cart';
      } finally {
        this.busy = window.hmKneeCartBusy = false;
        this.button.disabled = false;
        this.button.textContent = this.text('add') + ' — ' + this.money(offer.price);
        this.querySelectorAll('input[type=radio]').forEach(i => { i.disabled = this.config.offers[i.value]?.available === false; });
      }
    }
  }
  customElements.define('homyria-knee-offer', KneeOffer);
})();

